
$(document).ready(function () {
    const menu = document.getElementById('floating-menu');
    if (!menu) return;
    const fixed = menu.offsetTop;
    window.openOptions = function (randId) {
        var checkbox = document.getElementById('show-share-options-' + randId);
        checkbox.checked = !checkbox.checked;
    };
    document.addEventListener('click', function (event) {
        if ( ![...event.target.classList].some(className => className.includes('share')) ) {
            $('.share-buttons__social__show-options').prop('checked', false);
        }
    });
    window.addEventListener('scroll', () => {
        menu.classList.toggle('fixed', window.scrollY > fixed);
    });
});
document.addEventListener("DOMContentLoaded", function() {
    var shareButtons = document.querySelectorAll('.share');
    shareButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var linkElement = this.nextElementSibling;
            var url = linkElement.value;
            var tempInput = document.createElement("input");
            tempInput.value = url;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
        });
    });
});